import React from "react";
import { MDBCol, MDBContainer, MDBRow, MDBFooter, MDBBtn, MDBIcon } from "mdbreact";

const Footer = () => {
    return (
        <MDBFooter light className="font-small p-2">
            <MDBContainer fluid>
                <MDBRow>
                    <MDBCol md="6" className="text-left">
                        &copy; {new Date().getFullYear()} 
                        <a href="http://fuzzydigital.com/" alt=""> Fuzzy Digital Ltd </a>
                    </MDBCol>
                    <MDBCol md="6" className="text-right">
                        <a href="https://www.facebook.com/FuzzyDigitalCo/">
                            <MDBIcon fab icon="facebook-f" size="lg" className="mx-2 black-text mr-md-4"></MDBIcon>
                        </a>
                        <a href="https://twitter.com/FuzzyDigital">
                            <MDBIcon fab icon="twitter" size="lg" className="mx-2 black-text mr-md-4"></MDBIcon>
                        </a>
                        <a href="https://www.linkedin.com/company/fuzzy-digital/">
                            <MDBIcon fab icon="linkedin-in" size="lg" className="mx-2 black-text mr-md-4"></MDBIcon>
                        </a>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBFooter>
    );
}

export default Footer;